var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',[_c('div',[_c('Empty',{staticClass:"custom",attrs:{"image":_vm.icon}},[_c('div',{staticClass:"msg"},[_vm._v("该内容已失效，看看其他内容吧~")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }